import React, { type ComponentType } from 'react';
import { SafeRovoPanelSidebar } from '@jira/ai-rovo_panel/src/index.tsx';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { JswOnboardingChecklist } from '@atlassian/jira-software-onboarding-quickstart/src/ui/async.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { shouldRouteSkipOnboarding } from '../../common/utils.tsx';

const SafeRovoAiPanelFG = componentWithFG('jira_rovo_button_mvp', SafeRovoPanelSidebar, () => null);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RightSidebars: ComponentType<Record<any, any>> = () => {
	const route = useCurrentRoute();

	return (
		<>
			<SafeRovoAiPanelFG />
			{!shouldRouteSkipOnboarding(route.name) && <JswOnboardingChecklist />}
		</>
	);
};

export default RightSidebars;
